import { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { API_BASE_URL } from '../creds';
import Breadcrumb from './Breadcrumb';
import Markdown from "@uiw/react-markdown-preview";
// import NewsViewCard from './NewsViewCard';

const NewsDetailPage = () => {
  const { idAndSlug } = useParams();
  const id = idAndSlug.split("-")[0];
  const [newsItem, setNewsItem] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNewsItem = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const url = `${API_BASE_URL}/news/${id}`;
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Failed to fetch news item: ${response.statusText}`);
        }
        const data = await response.json();
        console.log('API response:', data);
        setNewsItem(data);
      } catch (err) {
        console.error('Fetch error:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchNewsItem();
  }, [id]);

  if (isLoading) {
    return <p className="text-center py-8">Loading...</p>;
  }
  if (error) {
    return <p className="text-reducchini500 text-center py-8">Error: {error}</p>;
  }
  if (!newsItem) {
    return <p className="text-center py-8">No news item found.</p>;
  }


  return (
    <div className="md:mx-20 mx-auto px-4 mt-8 min-h-screen">
      <Breadcrumb />
      <div className="text-sm mt-1 text-gray-500">
        <span>
          {newsItem.date
            ? new Date(newsItem.date).toLocaleDateString('en-US', {
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            })
            : 'Unknown date'}
        </span>
      </div>
      {/* <Link
        to="/"
        className="block text-start text-blue-600 hover:text-blue-800 hover:underline text-lg font-medium mt-0"
      >
        Back to Home Screen
      </Link> */}

      {/* <div className="border border-gray-200 py-2 pl-2">
          <NewsViewCard post={newsItem} />
          </div> */}

      <h1 className="text-3xl text-left  font-bold text-gray-800 mb-2">{newsItem.title || 'Untitled'}</h1>

      {newsItem.photo_url ? (
        <div className="w-full flex justify-left mb-4">
          <img
            src={`${API_BASE_URL}/images/${newsItem.photo_url}`}
            alt={newsItem.title || 'News Image'}
            className="w-[600px] h-[400px] rounded-lg"
            onError={(e) => {
              e.target.style.display = 'none';
              console.log('Image load error:', newsItem.photo_url);
            }}
          />
        </div>
      ) : (
        <div className="w-full h-64 bg-gray-200 flex items-center justify-center rounded-lg mb-4">
          <span className="text-gray-500">No Image</span>
        </div>
      )}

      <div className="markdown-override border border-gray-300 shadow-sm">
        <Markdown
          source={newsItem.descriptions || 'No content available'}
          style={{
            padding: 16,
            whiteSpace: 'pre-wrap',
            backgroundColor: 'transparent',
          }}
        />
      </div>
      <Link
        to="/"
       className="mx-auto block w-fit px-6 py-3 bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-200 hover:to-indigo-400 hover:text-gray-500 text-white text-2xl font-semibold rounded-2xl shadow-2xl hover:shadow-3xl  transition-all duration-300 relative my-2"
      >
        Back to Home
      </Link>
      {/* <Markdown style={{ padding: 16, whiteSpace: 'pre-wrap' }} source={newsItem.descriptions || 'No content available'} /> */}
    </div>
  );
};

export default NewsDetailPage;